import { Component, Input, OnInit } from '@angular/core';
import { Scorecard } from '@fgb/core';

@Component({
  selector: 'fgbcl-scorecard-sponser-view',
  templateUrl: './scorecard-sponser-view.component.html',
  styleUrls: ['./scorecard-sponser-view.component.scss']
})
export class ScorecardSponserViewComponent implements OnInit {
  @Input() scorecard: Scorecard;

  constructor() { }

  ngOnInit(): void {
  }

}
